import styled from 'styled-components';

/* Login: cabeçalho navy + card branco curvado sobreposto — mesma pegada do Control Zone / app mobile. */

export const Container = styled.div`
  min-height: 100vh;
  min-height: 100dvh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  max-width: none !important;
  width: 100%;
  box-sizing: border-box;
`;

export const HeaderGradient = styled.header`
  background: linear-gradient(135deg, #141234 0%, #0a0e27 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 56px 24px 24px;
  min-height: 460px;
  box-sizing: border-box;
  text-align: center;

  @media (max-width: 480px) {
    padding: 44px 16px 20px;
    min-height: 400px;
  }
`;

export const LogoWrapper = styled.div`
  img {
    display: block;
    width: 140px;
    height: auto;
    margin: 0 auto;
  }
`;

export const HeroTagline = styled.p`
  margin: 0;
  max-width: 360px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
  line-height: 1.5;
`;

export const Card = styled.div`
  position: relative;
  margin: -285px auto 0;
  background: #ffffff;
  border-top-left-radius: 28px;
  border-top-right-radius: 28px;
  box-shadow: 0 -8px 32px rgba(10, 14, 39, 0.12);
  /* deixa a sombra aparecer só no topo/laterais e corta a que vazaria embaixo */
  clip-path: inset(-60px -60px 0 -60px);
  width: 100%;
  max-width: 480px;
  padding: 40px 28px 72px;
  box-sizing: border-box;

  @media (max-width: 480px) {
    margin-top: -240px;
    padding: 32px 18px 60px;
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
  }
`;

export const Title = styled.h1`
  color: #161a2e;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 8px 0;

  @media (max-width: 767px) {
    font-size: 22px;
  }
`;

export const Subtitle = styled.p`
  margin: 0 0 24px;
  color: #5b6180;
  font-size: 0.92rem;
  line-height: 1.55;
  text-align: center;
`;

export const FormWrapper = styled.div`
  form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .MuiFormControl-root {
    width: 100%;
    margin: 0 !important;
  }

  /* Classes repetidas pra vencer o tema escuro global (styles/global.js) */
  .MuiOutlinedInput-root.MuiOutlinedInput-root.MuiOutlinedInput-root.MuiOutlinedInput-root {
    background: #eef0f6;
    color: #161a2e;

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: #0284c7 !important;
    }

    &.Mui-error .MuiOutlinedInput-notchedOutline {
      border-color: #dc2626 !important;
    }
  }

  .MuiFormControl-root > .MuiInputLabel-outlined.MuiInputLabel-outlined.MuiInputLabel-outlined {
    color: #5b6180 !important;

    &.Mui-error {
      color: #dc2626 !important;
    }
  }

  .MuiInputBase-input {
    color: #161a2e !important;
  }

  .MuiFormControl-root.MuiFormControl-root .MuiInputBase-input.MuiInputBase-input::placeholder {
    color: #8b90ab !important;
  }

  /* Neutraliza o fundo/texto que o navegador aplica no auto-preenchimento */
  .MuiInputBase-input:-webkit-autofill,
  .MuiInputBase-input:-webkit-autofill:hover,
  .MuiInputBase-input:-webkit-autofill:focus,
  .MuiInputBase-input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px #eef0f6 inset !important;
    box-shadow: 0 0 0 1000px #eef0f6 inset !important;
    -webkit-text-fill-color: #161a2e !important;
    caret-color: #161a2e;
    border-radius: 999px;
    transition: background-color 9999s ease-in-out 0s;
  }

  .MuiInputAdornment-root .MuiIconButton-root,
  .MuiSvgIcon-root {
    color: #5b6180 !important;
  }

  .MuiFormHelperText-root.Mui-error {
    color: #dc2626 !important;
    margin-left: 6px !important;
  }

  .signin-submit.MuiButton-root {
    width: 100%;
    height: 52px;
    margin-top: 8px;
    font-weight: 700;
    font-size: 16px;
    background: linear-gradient(135deg, #f29205 0%, #ff6b35 100%);
    color: #ffffff;
    text-transform: none;
    box-shadow: 0 4px 15px rgba(242, 146, 5, 0.3);
    transition: all 0.3s ease;

    .MuiSvgIcon-root,
    svg {
      color: #ffffff !important;
    }

    &:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(242, 146, 5, 0.4);
      background: linear-gradient(135deg, #f29205 0%, #ff6b35 100%);
    }

    &:disabled {
      opacity: 0.7;
      color: #ffffff;
    }
  }
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 20px 0 16px;
  color: #8b90ab;
  font-size: 13px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: rgba(15, 23, 42, 0.1);
  }
`;

export const FooterLink = styled.p`
  text-align: center;
  margin: 20px 0 0 0;
  color: #5b6180;
  font-size: 14px;

  a {
    color: #f29205;
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      color: #ff6b35;
    }
  }
`;

export const CopyrightWrapper = styled.div`
  margin-top: auto;
  padding: 28px 20px;
  color: #8b90ab;
  font-size: 12px;
  text-align: center;
`;
